import { fetchExpenseFeeModalCatalogs } from '@/composables/expensesFees/shared/useExpenseFeeModalCatalogsShared';

export const fetchFeeModalCatalogs = async () => {
  return fetchExpenseFeeModalCatalogs({
    includeCollaborators: true,
    resolveSalesCompanyIds: true,
  });
};
